import React, { lazy, Suspense, useState } from 'react';
import { useSelector } from 'react-redux';
import Header from './Header';
import Picture from './Picture';

const SideLeft = () => {
    const [showCompare,setShowCompare] = useState(false);
    
    const rendered_picture = useSelector(state => state.picture);
    const original_picture = useSelector(state => state.olgImg);

    const handleShowCmpare = () => {
        setShowCompare(prevState => !prevState);
    };

    const CompareComponnet = lazy(() => import('../../common/CompareImg') )

    return ( 
        <>
            <div className='side-left-header w-100 d-inline-block'>
                <Header handleShowCmpare={handleShowCmpare}/>
            </div>
            <div className='side-left-body w-100 d-inline-block css-nkyeax'>
                {showCompare ? <Suspense fallback={<div>لطفا منتظر بمانید...</div>}>
                    <CompareComponnet topImage={original_picture} bottomImage={rendered_picture.img}/>
                </Suspense> : <Picture Img={rendered_picture.img}/>}
            </div>
        </>
    );
}
 
export default SideLeft;